const haversine = require('haversine-distance');

// eslint-disable-next-line max-len
export default function calculateHaversineDistance(position1Lat, position1Lon, position2Lat, position2Lon) {
  const point1 = { latitude: position1Lat, longitude: position1Lon };
  const point2 = { latitude: position2Lat, longitude: position2Lon };
  return haversine(point1, point2);
}
